import React from "react";
import GenericInput from "../genericInput";
import ErrorMessage from "./errorMessage";

const Column = ({ props, errors }) => {
  return (
    <table align="center" width="100%" border="0">
      <tbody>
        <tr key={props.id}>
          {props.fields.map((field, i) => (
            <td key={i} width={field.props.width}>
              <GenericInput {...field} />
              <ErrorMessage name={field.props.name} errors={errors} />
            </td>
          ))}
        </tr>
      </tbody>
    </table>
  );
};
export default Column;
